import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
let cutOffLine = class cutOffLine extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      title: "",
      jsonConfig: {
        lineStyleType: "1",
        text: ""
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      "jsonConfig.lineStyleType": [{
        required: true,
        message: "请选择",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  async validate() {
    return true;
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], cutOffLine.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], cutOffLine.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], cutOffLine.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], cutOffLine.prototype, "watchPostForm", null);
cutOffLine = __decorate([Component({
  name: "cutOffLine",
  components: {
    questionSettingTemplate
  }
})], cutOffLine);
export default cutOffLine;